import { useMutation, useQuery } from '@tanstack/react-query';
import { CaseFinalDocumentModel } from 'app/edozvola/cases/cases.model';
import { showToast } from 'app/shared/util/toast.util';
import { ERRORS, messages } from 'app/config/constants';
import { toast } from 'react-toastify';
import { queryClient } from 'app/app';
import { fetchCaseFinalDocument, saveCaseFinalDocument } from 'app/edozvola/cases/service/cases.service';
import success = toast.success;

export const saveCaseFinalDocumentQuery = (idCase: string) => {
  return useMutation({
    mutationFn: (values: CaseFinalDocumentModel) => {
      return saveCaseFinalDocument(idCase, values);
    },
    onSuccess: () => {
      showToast(success, messages.DATA_SAVED);
      queryClient.invalidateQueries({ queryKey: ['case-final-document'] });
    },
    onError: (err: any) => {
      if (Object.values(ERRORS).includes(err.response?.data?.detail)) {
        showToast(toast.error, err.response?.data?.detail);
      } else {
        showToast(toast.error, ERRORS.GENERIC_ERROR);
      }
    },
  });
};

export const fetchCaseFinalDocumentQuery = (idCase: string) => {
  return useQuery({
    queryKey: ['case-final-document'],
    queryFn: () => fetchCaseFinalDocument(idCase),
  });
};
